<template lang="pug">
  ul.view
    li(:class="{'active': view == 1}")
      button(@click="change(1)")
        img(src="@/assets/ico_front.svg")
        img(src="@/assets/ico_front_on.svg")
    li(:class="{'active': view == 2}")
      button(@click="change(2)")
        img(src="@/assets/ico_side.svg")
        img(src="@/assets/ico_side_on.svg")
    li(:class="{'active': view == 3}")
      button(@click="change(3)")
        img(src="@/assets/ico_top.svg")
        img(src="@/assets/ico_top_on.svg")
</template>

<script>
import store from '../../stores';
export default{
  name: 'Views',
  data () {
    return {
    };
  },
  props: {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    change (num) {
      store.commit('setView', num);
    }
  },
  created () {
  }
};
</script>
<style lang="stylus" scoped>
  ul.view
    display flex
    align-items center
    border-radius 3px
    border 1px solid #dddddd
    background-color #ffffff
    height 33px
    overflow hidden
    li
      button
        width 50px
        height 33px
        border none
        background-color #ffffff
        img
          pointer-events none
        img:nth-child(1)
          display inline
        img:nth-child(2)
          display none
      &.active
        button
          background-color #2E7C80
          img:nth-child(1)
            display none
          img:nth-child(2)
            display inline
    li + li
      border-left  1px solid #dddddd

</style>



// WEBPACK FOOTER //
// src/components/status/Views.vue